import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-70891ff3")

_pushScopeId("data-v-70891ff3")
const _hoisted_1 = {
  "data-testid": "booking-check-tariff",
  class: "total-tariff-section"
}
const _hoisted_2 = {
  key: 0,
  class: "total-tariff-section__state"
}
const _hoisted_3 = {
  key: 1,
  class: "total-tariff-section__state text-16px text-gray-lp-300",
  "data-testid": "booking-v4-tarif-error"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "total-tariff-section__title"
}
const _hoisted_6 = {
  key: 1,
  class: "total-tariff-section__discounts"
}
const _hoisted_7 = {
  key: 0,
  class: "summary-discount-chip summary-discount-chip--label",
  "data-testid": "txn-booking-label-promo-info"
}
const _hoisted_8 = { class: "total-tariff-section__amount" }
const _hoisted_9 = { "data-testid": "edit-booking-summary-price" }
const _hoisted_10 = {
  key: 0,
  class: "total-tariff-section__original",
  "data-testid": "booking-v4-tarif-original-price"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_detail_estimation = _resolveComponent("detail-estimation")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_skeleton, {
            height: "2.1rem",
            width: "16.7rem"
          })
        ]))
      : (_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.footer.error")), 1),
            _createVNode("button", {
              type: "button",
              class: "total-tariff-section__refresh",
              "aria-label": _ctx.$t('bookingV4.footer.refresh'),
              "data-testid": "booking-v4-tarif-refresh",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh')))
            }, [
              _hoisted_4
            ], 8, ["aria-label"])
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            (!_ctx.isReverseJourney)
              ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true),
            (_ctx.hasAnyDiscount)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.combinedPromoDiscountLabel)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.combinedPromoDiscountLabel), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_8, [
              _createVNode("button", {
                ref: "detailEstimationTrigger",
                type: "button",
                class: ["total-tariff-section__amount-button", { 'is-disabled': !_ctx.canOpenDetail }],
                disabled: !_ctx.canOpenDetail,
                "aria-expanded": _ctx.canOpenDetail ? String(_ctx.isShow) : undefined,
                "data-testid": "txn-booking-label-tariff-amount",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeydownTrigger && _ctx.onKeydownTrigger(...args)))
              }, [
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.displayPrice), 1),
                (_ctx.canOpenDetail)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.chevronIcon,
                      alt: _ctx.isShow ? 'collapse' : 'expand'
                    }, null, 8, ["src", "alt"]))
                  : _createCommentVNode("", true)
              ], 42, ["disabled", "aria-expanded"]),
              (_ctx.showOriginalStrikethrough)
                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.currency(_ctx.originalValue)), 1))
                : _createCommentVNode("", true)
            ])
          ], 64)),
    _createVNode(_component_OverlayPanel, {
      ref: "detailEstimationOverlay",
      appendTo: "body",
      baseZIndex: 2000,
      dismissable: false,
      class: ["detail-estimation-overlay", {
        'reverse-journey-overlay': _ctx.isReverseJourney
      }]
    }, {
      default: _withId(() => [
        _createVNode(_component_detail_estimation, {
          modelValue: _ctx.modelValue,
          isShow: _ctx.isShow && _ctx.canOpenDetail,
          estimationPrice: _ctx.estimationPrice,
          currencyPrefix: _ctx.currencyPrefix,
          codCurrencyPrefix: _ctx.resolvedCodCurrencyPrefix,
          codCurrencyCode: _ctx.resolvedCodCurrencyCode,
          isCod: _ctx.isCod,
          isDfod: _ctx.isDfod,
          itemPrice: _ctx.itemPrice,
          woodpacking: _ctx.woodpacking,
          protectionChecked: _ctx.protectionChecked,
          isFtz: _ctx.isFtz,
          appliedVoucherCode: _ctx.appliedVoucherCode,
          isCrossCountryCod: _ctx.isCrossCountryCod,
          hideCodReturnFee: _ctx.hideCodReturnFee
        }, null, 8, ["modelValue", "isShow", "estimationPrice", "currencyPrefix", "codCurrencyPrefix", "codCurrencyCode", "isCod", "isDfod", "itemPrice", "woodpacking", "protectionChecked", "isFtz", "appliedVoucherCode", "isCrossCountryCod", "hideCodReturnFee"])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
})